export const richmenuRefetcher: {
  refetch: null | (() => void);
} = {
  refetch: null,
};
